"use client"

import React from "react"
import { useFormStatus } from "react-dom"
import { Loader2 } from "lucide-react"

export function SubmitButton({
  children,
  variant = "primary",
  className,
  "data-testid": dataTestId,
}: {
  children: React.ReactNode
  variant?: "primary" | "secondary" | "transparent" | "danger" | null
  className?: string
  "data-testid"?: string
}) {
  const { pending } = useFormStatus()

  const base = "inline-flex items-center justify-center rounded-md px-6 py-3 text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
  const variants: Record<string, string> = {
    primary: "bg-brand-primary text-white hover:bg-brand-primary-dark",
    secondary: "bg-white text-brand-primary border border-brand-primary hover:bg-gray-50",
    transparent: "bg-transparent text-brand-primary hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700",
  }

  return (
    <button
      className={`${base} ${variants[variant || "primary"]} ${className || ""}`}
      type="submit"
      disabled={pending}
      data-testid={dataTestId}
    >
      {pending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {children}
    </button>
  )
}
